import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { EdwardColors } from 'enums';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: { dialog?: boolean }) => ({
      padding: props.dialog ? 0 : theme.spacing(2, 2, 5, 2),
    }),
    wrapper: (props: { dialog?: boolean }) => ({
      padding: props.dialog ? 0 : undefined,
    }),
    dialog: {
      padding: 0,
    },
    loading: {
      marginRight: theme.spacing(2),
    },
    disabled: {
      color: EdwardColors.GRAY_MEDIUM
    },
    card: (props: { dialog?: boolean }) => ({
      backgroundColor: theme.palette.grey[100],
      height: '100%',
      position: 'relative',
      overflow: 'hidden',

      '& .cta': {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        textAlign: 'center',
      },
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: theme.palette.grey[300],
      },
      '& button': {
        width: 'auto',
        margin: theme.spacing(0, 0, 2),
      },
    }),
    cardContent: {
      height: '100%',
    },
    new: {
      '& .MuiCardContent-root':{ padding: (theme.spacing(2,5))},
      '&:after': {
        display: 'block',
        content: `"Nově 0,40 % p.a."`,
        position: 'absolute',
        right: '-44px',
        top: '32px',
        transform: 'rotate(45deg)',
        background: '#cd80ff',
        color: '#fff',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: theme.spacing(0.5, 1),
        width: '175px',
        textAlign: 'center',
        //textTransform: 'uppercase'
      },
    },
    insert: {
      marginTop: theme.spacing(6),
      display: 'flex',
      justifyContent: 'center'
    }
  }),
);

export default useStyles;
